"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIbsscToken = void 0;
const API_1 = require("../API");
const getIbsscToken = async (bearerToken, url = '/api/root/authentication/userAccessTokens/ibssc') => {
    const ibsscTokenRoutes = (0, API_1.createRoutes)(url, bearerToken, (axiosInstance) => ({
        getIbsscToken: () => {
            return axiosInstance.get('');
        },
    }));
    const api = (0, API_1.createRoutesProxy)(ibsscTokenRoutes);
    return api
        .getIbsscToken()
        .then(({ data }) => {
        return data;
    })
        .catch((error) => {
        return Promise.reject(error);
    });
};
exports.getIbsscToken = getIbsscToken;
